import(/* webpackMode: "eager" */ "/var/www/victorshop/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/victorshop/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/contents/bimageslider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/contents/blogposts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/contents/blurbox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/contents/companies.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/contents/DashboardCards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/contents/features.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/contents/FeatureSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/contents/games.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/contents/hero-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/contents/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/contents/platforms.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/contents/pricing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/contents/shoppingcard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/contents/testimonial.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/contents/thumbnail.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/victorshop/src/components/global/container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/header/dashboard-navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/header/menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/header/mobile-navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/header/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/var/www/victorshop/src/components/providers/CartContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/providers/SessionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/sections/forgot-password-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/sections/login-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/sections/product-manage/EditProductSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/sections/product-manage/ProductManageSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/sections/register-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/sections/verify-phone-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Particles"] */ "/var/www/victorshop/src/components/ui/particles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedCircularProgress"] */ "/var/www/victorshop/src/components/utils/animated-circular-progress-bar.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/victorshop/src/components/utils/animation-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/utils/animation-switch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/utils/DynamicSelect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/utils/Notification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/utils/otp-input.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/utils/TagInputs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/victorshop/src/components/wrappers/SidebarWrapper.tsx");
